import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useSelector } from 'react-redux';
import { errorAlert } from 'helpers/alerts';
import { BackButton, ErrorCodesProviderForm } from 'components';
import { updateProviderCredsErrorCodesService } from 'services/admin/providerService';
import { Grid } from '@mui/material';

function EditErrorCodesScreen() {
    const navigate = useNavigate();
    const { current, errorCodeSelected } = useSelector(store => store.providers)

    return (
        <>
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                mt={2}
            >
                <div>
                    <BackButton click={() => navigate(-1)} />
                </div>
                <div className="container-title">
                    <div className="title">Proveedor</div>
                    <div className="subtitle">{current?.container_name ?? "-"}</div>
                </div>
                <div style={{ width: "170px" }}></div>
            </Grid>
            <ErrorCodesProviderForm
                title={"Cancelar"}
                defaultValues={{
                    hebeExceptionCode: errorCodeSelected.hebeExceptionCode,
                    externalExceptionCode: errorCodeSelected.externalExceptionCode
                }}
                goBack={() => {
                    navigate(-1);
                }}
                submit={(data) => {
                    data['connectorName'] = current?.host;
                    try { delete data['id'] } catch (e) { }
                    updateProviderCredsErrorCodesService(errorCodeSelected.id, data).then((result) => {
                        navigate(-1);
                    }).catch((e) => {
                        errorAlert(e);
                    });
                }}
            />
        </>
    );
}

export default EditErrorCodesScreen;